export default {
    site: {
        common: {
            hello: "Ciao",
            thankYou: "Grazie",
            forMoreInfo: "Per maggiori informazioni",
            hoverOverColumnHeaders: "Passa il mouse sopra le intestazioni delle colonne per ulteriori informazioni.",
            username: "Giocatore",
            score: "Punteggio",
            points: "Punti",
            pointsAbbreviation: "pt",
            chapter: "Capitolo",
            tier: "Era",
            t1: "1°Era",
            t2: "2°Era",
            t3: "3°Era",
            collectionsPerDay: "Raccolte Al Giorno",
            relicBoostPercent: "% Bonus Cimeli",
            mountainHallPercentShort: "% Sale di Montagna", // used in table heading keep it short.
            updated: "Aggiornato",
            lastUpdated: "Ultimo aggiornamento",
            created: "creato",
            role: "Ruolo",
            Fellow: 'Membro',
            Ambassador: 'Ambasciatore',
            Mage: 'Mago',
            Archmage: 'Arcimago',
            saveChanges: "Salva Cambiamenti",
            copy: "Copia",
            close: "Chiudi",
            cancel: "Cancella",
            action: "Azione",
            date: "Data",
            Left: "Uscito",
            Joined: "Entrato",
            human: "Umano",
            elf: "Elfo",
            search: "Cerca",
            enter: "Inserisci",
            yes: "Si",
            no: "No",
            tournament: "Torneo",
            tournaments: "Tornei",
            fellowship: "Compagnia",
            player: "Giocatore",
            member: "Membri",
            history: "Cronologia",
            tournamentHistory:  "Cronologia Tornei",
            scoreHistory: "Cronologia Punteggio",
            server: "Server",
            lastWeekGain: "Crescita Ultima Settimana",
            comingSoon: "Prossimamente",
            chest: "Scrigno",
            yourServer: "Il tuo server",
            allServers: "Tutti i server",
            boosts: "Bonus",
            marble: "marmo",
            steel: "acciaio",
            planks: "assi",
            crystal: "cristallo",
            scrolls: "pergamene",
            silk: "seta",
            elixir: "elixir",
            magic_dust: "polvere magica",
            gems: "gemme",
            sentient: "senziente",
            goods: "merci",
            average: "media",
            expansions: 'Espansioni', // 5x5 grids
            cultureBoostMinimum: 'Bonus Cultura minimo',
            cultureBoostCalculated: 'Bonus Cultura Calcolato',
            neighborlyHelp: 'Aiuto del Vicinato',
            neighborlyHelpAbbreviation: 'AV'
        },
        // HIGH PRIORITY
        nav: {
            home: "Home",
            players: "Giocatori",
            fellowships: "Compagnie",
            tournaments: "Tornei",
            contact: "Contatti",
            donate: "Donazioni",
            faq: "FAQ",
            news: "News",
            privacyPolicy: "Privacy Policy",
            me: "Io",
            myFellowship: "La Mia Compagnia",

            // NOTE USED AT THE MOMENT
            globalStats: "Statistiche Globali",
            articles: "Articoli",
            fellowshipAdventure: "Avventura Di Compagnia",
            recruit: "Recluta",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Visualizza la città su ElvenArchitect"
            ,obtainingLink: "Creazione Link"
            ,successMessage: "Successo! Fare clic sul collegamento sottostante per avviare Elven Architect"
            ,ageOfLink: "Il link sopra mostrerà la città com'era: "
            ,clickToGetCurrentCity: "<-- Clicca per ottenere la città attuale",
        },
        // High Priority
        playerSelection: {
            headline: "Visualizza il sito come",
            description: "Questo aggiornerà varie parti del sito che sono personalizzate per l'utente del sito. Gli esempi includono: la mia compagnia, il mio utente, i tornei e le pagine di classifica.",
            youAreViewing: "Stai visualizzando il sito come {username} su {serverName}.",
            changeUser: "Cambia Giocatore",
            enterYourUsernameToGetStarted: "Inserisci il tuo Nickname di Elvenar per iniziare",
            thisIsNotASignup:"Questa non è una procedura di registrazione. Inserendo il tuo nickname, personalizziamo semplicemente il sito in modo appropriato. Ci sono molti server Elvenar e mostreremo i risultati del ranking per il tuo server. Inoltre, la tua compagnia e i link alle tue pagine utente personali saranno disponibili."
        },
        searchBoxes: {
            enterFellowshipName: 'Inserisci il Nome della Compagnia',
            instructions: "Digita il nome e Selezionane uno.",
            noFellowship: "Nessuna Compagnia",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "giorni fa",
            minsAgo: "minuti fa",
            hoursAgo: "ore fa",
            justNow: "adesso",
            never: "mai",
        },
        home: {
            welcome: "Benvenuto su Elven Stats!",
            youAreViewing: "Stai visualizzando il sito come {username} su {serverName}",
            youCanChange: "È possibile modificare l'utente facendo clic sull'avatar in alto a destra, oppure <router-link to='/contact'>visitando questa pagina</router-link>",
            features: {
                headline: "Caratteristiche",
                fellowshipAdministration: {
                    headline: "<strong>FACILE</strong> Gestione della Compagnia",
                    bullet1: "Tracciamento automatico dei beni potenziati per aiutarti a bilanciare meglio la tua compagnia",
                    bullet2: "Tracciamento/Generazione automatica di report settimanali che includono punti, partecipazione al torneo, crescita mensile, riconoscimenti e migliori record personali",
                    bullet3: "Aiuta a identificare gli squilibri di produzione dei membri della tua compagnia come quantità o rapporto tra risorse",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Integrazione</strong> con ElvenArchitect",
                    description: "Carica la tua città esattamente come è, in ElvenArchitect in pochi secondi! Usalo per pianificare meglio la tua prossima riorganizzazione della città o per trovare uno spazio che non sai di avere! Cerca il logo ElvenArchitect sulle pagine dei giocatori."
                },
                advancedRankingLists: {
                    headline: "<strong>Classifiche</strong> Avanzate in tabelle",
                    bullet1: "Classifica per aree sbloccate (per confrontarti con persone allo stesso livello)",
                    bullet2: "Visualizza Bonus produzione, Numero capitolo e altro negli elenchi di giocatori.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Monitoraggio</strong> Tornei Compagnie",
                    description: "Guarda com'è posizionata la tua compagnia rispetto alle altre. Sfida a duello le altre compagnie per una competizione amichevole!",
                },
                matchMaking: {
                    headline: "Match <strong>Making</strong>",
                    description: "ElvenStats tiene traccia dei bonus dei giocatori e dei rapporti di produzione di beni delle compagnie. Con queste informazioni, le compagnie possono reclutare i candidati giusti per bilanciare i loro beni. Gli utenti alla ricerca di una compagnia possono trovare compagnie che hanno BISOGNO dei loro potenziamenti. Risparmio di tempo e meno probabilità di un rifiuto!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Posizione",
                points: "Punti",
                medianUserScore: "<strong>Punteggio Medio</strong> Giocatori",
                memberCount: "<strong>Numero</strong> Membri",
            },
            barCharts: {
                clickSlice: "Fare clic su una sezione per i dettagli (per membro)",
                tier1: "Beni 1° Era",
                tier2: "Beni 2° Era",
                tier3: "Beni 3° Era",
                drillDown: 'Torna a {0}'
            },
            idealCandidate: {
                heading: "Candidato Ideale",
                description: 'Dovrebbe avere un punteggio intorno a {medianScore} e uno o più dei seguenti bonus: {boosts}',
                note: "Alcune combinazioni di bonus non sono possibili. Vedi {0}"
            },
            memberGoodsTable: {
                heading: "Produzione Risorse dei Membri",
                description: "Questa tabella calcola la quantità di risorse che produce la tua compagnia. Si è ipotizzato la possibile percentuale bonus per le produzioni dei membri e per impostazione predefinita, assumiamo che ogni membro faccia 3 raccolte al giorno (2x9h e 1x3h). Per migliorare l'accuratezza, chiedi ai membri della tua compagnia quali sono i loro valori effettivi e inseriscili di seguito. Puoi salvare ciò che inserisci in modo che venga visualizzato la prossima volta che carichi questa pagina. I grafici a barre sopra si aggiornano automaticamente dopo aver apportato le modifiche. Passa il mouse sopra la intestazioni delle colonne per ulteriori informazioni di una particolare colonna.",
                refreshButtonText: 'Aggiorna la lista dei Membri',
                refreshButtonTip: 'Questo aggiungerà nuovi membri, rimuoverà vecchi membri, aggiornerà i ruoli nella compagnia e aggiornerà i punteggi correnti.',
                inactiveWarningTip: 'Lutente potrebbe essere inattivo, punteggio ultimo aggiornamento: {0}',
                collectsPerDayValidation: "Deve essere tra 1-6",
                boostPercentValidation: "Deve essere tra 40 e 700, non include il bonus di Sale di Montagna",
                perDayShort: "/g",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Punti Giocatore.Si prega di notare che il punteggio dei giocatori non viene aggiornato in tempo reale. È aggiornato più volte alla settimana.",
                chapterTip: "Questo è il capitolo in cui si trova ogni giocatore.  Per confrontare: Elementali = 12, Halfling = 11, etc.",
                boostTip: "Il Bonus del giocatore e la quantità di risorse PRODOTTA al giorno.",
                collectsPerDayTip: "***EDITABILE*** <br/>Raccolte al giorno. Questo è il numero di volte al giorno in cui il giocatore raccoglie le merci dalle manifatture. Deve avere un valore compreso tra 1 e 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Si prega di consultare le FAQ per ulteriori informazioni.",
                relicBoostPercentTip: "***EDITABILE***<br/>La %Bonus dei cimeli è tra 40 e 700 e non include la percentuale bonus di Sale di Montagna.Esso viene rilevato e aggiunto automaticamente a questo numero",
                mountainHallPercentTip: "Questa è la %Bonus di Sale di Montagna rilevata per questo giocatore. Viene utilizzato insieme alla %Bonus per calcolare la percentuale di bonus totale.",
                updatedTip: "Questo è il momento in cui è stata analizzata l'ultima volta la città dei giocatori. Questo processo è ciò che determina i bonus, i dati di Elvenarchitect, calcola la produzione di tutte le manifatture, la % di Sale di Montagna e altro. I dati della mappa della città vengono recuperati periodicamente automaticamente, ma puoi forzare un aggiornamento, facendo click sul pulsante Aggiorna.",

            },
            coinsAndSuppliesTable: {
                heading: "Produzioni Monete / Materiali",
                description: "La colonna chiave in questa tabella è 'materiali rimanenti' in quanto indica se un membro produce materiali sufficienti per mantenere la produzione delle sue manfatture 24/7.Premi sulle levette qui sotto per attivare o disattivare il bonus cultura dei giocatori (calcolato senza tener conto dell'aiuto del vicinato) e il numero di raccolte al giorno (come specificato nella Tabella delle risorse qui sopra).Disattivare entrambi è utile se si desidera vedere la quantità di materiali attribuiti a più manifatture o ad un bonus cultura più elevato.Infine, tieni presente che avere una quantità negativa di materiali rimanenti (attorno a -10% del totale) è alquanto comune.Ci sono molti modi in cui i giocatori integrano la produzione di materiali, ad esempio visitando i vicini, producento materiali ad intervalli più rapidi (bevande, attrezzi semplici, pane...) o utilizzando gli incantesimi 'il potere delle provviste' Pensa al valore negativo come ciò che dovresti recuperare giornalmente effettuando una di queste opzioni. NOTA: al momento la produzione di truppe non viene presa in considerazione nei materiali utilizzati (vengono prese in considerazione solo le produzioni da manifatture di 1°, 2° e 3° era) quindi potresti aver bisogno di più materiali",

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "% Bonus Min.",
                made: "Prodotti",
                used: "Usati",
                left: "Rimanenti",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "La percentuale di Bonus Cultura. IMPORTANTE: questo è calcolato SENZA L'AIUTO DEL VICINATO. In realtà il valore sarà probabilmente più alto nelle vostre città.",
                moneyComputedTip: "Quantità di monete prodotte in un giorno, include quanto prodotto dalle Antiche Meraviglie che producono monete",
                moneyUsedComputedTip: "La quantità di monete che si consumano per produrre beni.",
                moneyRemainingComputedTip: "Monete - Monete usate, è il surplus/deficit di monete giornaliero disponibile ogni giorno l giocatore",
                suppliesComputedTip: "La quantità di materiali che verrebbe prodotta se tutti i laboratori fossero impostati a 24x1 (cassette degli attrezzi) + eventuali meraviglie antiche. (non include i bonus dei set di edifici)",
                suppliesUsedComputedTip: "La quantità di materiali consmati producento beni. NON considera i materiali consumati dalla caserma! Vedi la spiegazione sopra.",
                suppliesRemainingComputedTip: "Materiali - Materiali Usati, è il surplus o deficit di materiali che il giocatore ha ogni giorno",
                manaTip: "la quantità di mana prodotta in 24h (non considera l'abbazia del drago)",
            },
            popCultureTable: {
                heading: "Dettagli Popolazione/Cultura",
                description: 'La tabella mostra i dettagli di popolazione e cultura per ogni membro. Scorri sopra le intestazioni delle colonne per maggiori dettagli.',

                // Icon Sub-Headings
                minBoostPercent: "Min Boost %",
                levels: "Livelli",
                total: "Totale",
                working: "Working",
                available: "Disponibile",
                required: "Richiesto",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Il numero complessivo di livelli delle meraviglie antiche",
                cultureBoostPercentTip: "La percentuale di bonus cultura.  IMPORTANTE: è calcolato SENZA CONSIDERARE L'AIUTO DEL VICINATO. Il bonus cultura effettivo sarà probabilmente più elevato",
                totalPopulationTip: "Il totale della popolazione prodotta da residenze, edifici ibridi cultura/popolazione e meraviglie antiche",
                workingPopulationTip: "Popolazione al lavoro - La quantità consumata agli edifici",
                availablePopulationTip: "Popolazione disponibile",
                totalCultureTip: "Il totale della cultura prodotta da edifici di cultura, edifici ibridi cultura/popolazione e meraviglie antiche",
                requiredCultureTip: "Cultura richiesta da tutti i tuoi edifici",
                availableCultureTip: "Cultura disponibile",
            },
            cityCoverageTable: {
                heading: "Copertura Città",
                description: "Mostra quanti quadretti vengono utilizzati in ogni città per il particolare tipo di edificio. I quadretti vuoti sono quadretti che al momento non vengono utilizzati.",
                tiles: 'Quadretti'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Messaggio Report Settimanale",
                description: "Viene generato automaticamente un report settimanale adatto alla condivisione con i membri della tua compagnia. Un nuovo report settimanale sarà disponibile ogni domenica (circa alle 20:00 UTC) per la settimana precedente. Copia semplicemente la descrizione qui sotto e incollalo nella tua Compagnia!",
                selectReportHint: "Seleziona il report Settimanale",
                reportsAreOptimizedFor: "I report sono ottimizzati per la visualizzazione nel sistema di messaggistica di Elvenar in modo tale che le colonne siano allineate nel modo più appropriato possibile e i nomi dei giocatori vengano troncati in modo che si inseriscano in un singolo messaggio.",
                accolades: "Riconoscimenti",
                tourneyChamp: " - Campione del torneo (questa settimana): {0}",
                tourneyHero: " - Eroe del torneo (ultime 4 settimane): {0}",
                highestGrowthPlusPercentage: " - Crescita massima (punti e percentuale): {0}",
                highestGrowthPoints: " - Crescita massima (punti): {0}",
                highestGrowthPercentage: " - Crescita massima (percentuale): {0}",
                highestGrowthError: " - Crescita massima: Non può ancora essere determinata, serve più cronologia",
                newPersonalRecords: "Nuovi Record Personali",
                userSetANewPersonalRecordFor: " * {0} ha raggiunto un nuovo record personale per: {1}",
                allMembersByPointGainThisWeek: "Punti Guadagnati/Percentuale (questa settimana) per TUTTI I MEMBRI",
                tournamentPointsHeader: "Punti TORNEO (questa settimana / TOTALI DAL {0})",
                top8ByPercentage: "TOP 8 Per percentuale (questa settimana)",
                top8ByPointsSince: "TOP 8 per punteggio (Dal {0})",
                top8ByPercentageSince: "TOP 8 per percentuale (Dal {0})",
                reportGeneratedBy: "Report generato da elvenstats.com, per ulteriori informazioni: ",
                mostPointsInAWeek: "Più Punti in una settimana",
                highestTournamentScore: "Punteggio più alto al Torneo",
                highestTournamentRank: "Miglior posizionamento in Classifica Torneo",
                insufficientHistoryForThesePlayers: "* Omesso: {0} a causa di una cronologia insufficiente. Saranno inclusi la prossima settimana",
                insufficientHistory1Week: "* Cronologia insufficiente per questa sezione. Controlla la prossima settimana!",
                insufficientHistory4Weeks: "* Cronologia insufficiente per questa sezione. Sono necessarie almeno 4 settimane di cronologia. Torna presto!",
            },
            memberHistory: {
                heading: "Cronologia Membri",
                noChangesDetected: "Nessuna modifica dei membri è stata ancora rilevata da quando è iniziato il monitoraggio della compagnia {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Hai modifiche non salvate. Al termine della modifica della tua Compagnia, fai click sul pulsante Salva.',
                standbyImporting: 'Attendi: stiamo importando alcune informazioni mancanti dei tuoi compagni',
                limitedHistory: "Di recente abbiamo iniziato a tenere traccia di questo {0}, quindi la cronologia è limitata. Ogni domenica, le istantanee settimanali verranno visualizzate qui, quindi assicurati di controllare presto!",
                noChangesSinceTrackingBegan: "Nessuna modifica dall'inizio del monitoraggio",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Cronologia Compagnie"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Echtzeit-Updates sind zurzeit nicht verfügbar.",
            realTimeUpdatesNotAvailableDescription: "Dies geschieht in der Regel, nachdem die Elvenar Spieleserver neu gestartet wurden, um ein Update zu installieren oder um Wartungen durchzuführen.  Sobald dies der Fall ist, muss sich ElvenStats manuell bei allen Spieleservern anmelden, bevor Informationen wieder auf Anfrage abrufbar sind.  Bitte wiederhole deine Anfrage in ein paar Stunden.  Währenddessen ist die Seite vollständig funktionsfähig.",
            copyToClipboardSuccessful: "Kopieren in die Zwischenablage erfolgreich!",
            copyToClipboardFailed: "Kopieren fehlgeschlagen, markiere den gesamten Textbereich und drücke Strg+C",
            errorOccurredImporting: "Fehler aufgetreten beim Importieren der Benutzer.",
            errorOccurredImportingMessage: "Beim Importieren der Benutzer ist ein Fehler aufgetreten.  Bitte versuche es erneut.  Wenn der Fehler weiterhin besteht, kontaktiere uns bitte.",
            errorOccurredImportingWillNotBeAvailableInReports: "Benutzer, die nicht importiert wurden, werden nicht mit in die Berichte aufgenommen.",
            finishedSyncSuccessful: "Abgeschlossen, Synchronisation war erfolgreich!",
            playerIsAnonymous: "Der Spieler hat beantragt, dass seine Daten nicht auf elvenstats.com zu sehen sind.",
            inactiveWarningTip: "Dieser Spieler ist möglicherweise inaktiv.  Letzte Änderung des Punktestandes: {0}",
            isFriendTip: "Dieser Spieler ist ein Freund von ElvenStats.  Er hat entweder seine Zeit investiert oder Geld gespendet, um die Seite zu unterstützen!",
        },

    }
}


// WEBPACK FOOTER //
// ./src/lang/it.js